import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Norwegian route — permanent redirect to the German path
export const Route = createFileRoute("/artikler/")({
  beforeLoad: () => {
    throw redirect({ to: "/ratgeber", statusCode: 301 });
  },
});
